"use client";

import { useState } from "react";
import SolarIcon from "@/components/ui/SolarIcon/SolarIcon";

export default function CopyCode({ code }) {
    const [isCopied, setIsCopied] = useState(false);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(code);
            setIsCopied(true);
            setTimeout(() => setIsCopied(false), 2000);
        } catch (err) {
            console.error("Erreur lors de la copie :", err);
        }
    };

    return (
        <button
            onClick={handleCopy}
            className="p-1.5 rounded-md text-gray-500 dark:text-grayDark-400 hover:text-gray-700 dark:hover:text-grayDark-200 hover:bg-gray-200 dark:hover:bg-bgDark-400 transition-colors"
            aria-label="Copier le code"
        >
            {isCopied ? (
                <SolarIcon name="unread-linear" className="w-4 h-4 text-green-500" />
            ) : (
                <SolarIcon name="copy-linear" className="w-4 h-4" />
            )}
        </button>
    );
}
